import { ace } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function upsert({ url: { service: baseURL }, token }: IAPI) {
  return async function upsert(req: ace.UpsertRecentApplicationReq): Promise<void> {
    const url = new URL('/ace/opened-applications', baseURL);
    try {
      const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(req),
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
    } catch {
      throw new Error('Failed to upsert opened application');
    }
  };
}

export function getRecentlyOpenedApplications({ url: { service: baseURL }, token }: IAPI) {
  return async function getRecentlyOpenedApplications(req: ace.GetRecentlyOpenedApplicationsReq): Promise<ace.GetRecentlyOpenedApplicationsRes> {
    const url = new URL('/ace/opened-applications/recent', baseURL);
    for (const [key, value] of Object.entries(req)) {
      url.searchParams.set(key, value);
    }
    try {
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Authorization: token,
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    } catch {
      throw new Error('Failed to get recently opened applications');
    }
  };
}
